<template>
  <div v-if="sliderLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
  <div v-if="sliderError" class="mc-error">{{ sliderError }}</div>
  <div v-if="sliderLoaded" class="cr-hero-slider">
        <swiper
            wrapperTag="ul"
            :modules="modules"
            :scrollbar="{ draggable: true, el: '.swiper-scrollbar'+uniqueId}"
            :pagination="false"
            class="cr-hero-slider__wrapper swiper"
            wrapperClass="cr-hero-slider__list swiper-wrapper">
          <swiper-slide v-for="item in slider" class="cr-hero-slider__item swiper-slide" tag="li">
            <picture class="cr-hero-slider__picture">
              <img class="cr-hero-slider__image" :src="item.image  " width="330" height="450" alt="">
            </picture>
            <div class="cr-hero-slider__body">
              <div class="cr-hero-slider__title">
                {{ item.name }}
              </div>
              <router-link class="cr-button" :to="item.button_url">
                                    <span class="cr-button__text">
                                        {{ item.button_text }}
                                    </span>
              </router-link>
            </div>
          </swiper-slide>
          <template v-slot:container-end><div :class="'swiper-scrollbar swiper-scrollbar'+uniqueId"></div></template>
        </swiper>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
export default {
  data: () => ({
    modules: [Pagination, Navigation, Scrollbar],
    uniqueId: 'slider'
  }),
  created() {
    this.fetchSlider();
  },
  computed: {
    ...mapGetters('slider', [
      'slider',
      'sliderLoading',
      'sliderError',
      'sliderLoaded'
    ]),
  },
  components: {
    Swiper,
    SwiperSlide
  },
  methods: {
    ...mapActions('slider', [
      'fetchSlider'
    ]),
  },
}
</script>
